module.exports = __webpack_public_path__ + "static/img/news_program_2.ffe2f7ab.jpg";